import './App.css';

import Routes from '@/routes/index';
import ScrollToTop from './components/ScrollToTop';

function App() {
    return (
        <div className="App">
            <ScrollToTop />
            <Routes />
        </div>
    );
}

export default App;
